import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorMessage } from 'src/app/interfaces/errorMessage';
import { ErrorManagerService } from 'src/app/services/error-manager.service';
 
@Component({
    selector: 'app-error-bar',
    templateUrl: './error-bar.component.html',
    styleUrls: ['./error-bar.component.scss'],
    standalone: false
})
export class ErrorBarComponent implements OnInit, OnDestroy {
  errorMessage?: ErrorMessage;
  subscription?: Subscription;

  constructor(
    private errorManager: ErrorManagerService,
  ) {
    this.errorMessage = errorManager.lastError;
  }

  ngOnInit(): void {
    this.subscription = this.errorManager.errorStream$.subscribe((message: ErrorMessage) => this.errorMessage = message);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  closeError() {
    this.errorMessage = null;
    this.errorManager.clearLastError();
  }
}
